import React from "react";
import {
  Box,
  Button,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import {
  useGetMyReviewsQuery,
  useGetMyInvitesQuery,
  useAcceptInviteMutation,
} from "../../services/review.service";

const Reviews = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useGetMyReviewsQuery();
  const { data: invitesData } = useGetMyInvitesQuery();
  const [acceptInvite] = useAcceptInviteMutation();

  const reviews = data?.reviews || [];
  const invites = (invitesData?.invites || []).filter((i) => i.review);

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="Systematic Review Screening" subtitle="Import, screen and export systematic reviews" />

      {invites.length > 0 && (
        <Paper sx={{ p: 2, mt: 2 }}>
          <Typography variant="h6" mb={1}>Pending invites</Typography>
          <List dense>
            {invites.map((invite) => (
              <ListItem
                key={invite._id}
                secondaryAction={
                  <Button variant="contained" size="small" onClick={() => acceptInvite(invite._id)}>
                    Accept
                  </Button>
                }
              >
                <ListItemText primary={invite.review.title} secondary={invite.review.question} />
              </ListItem>
            ))}
          </List>
        </Paper>
      )}

      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Button variant="contained" color="primary" onClick={() => navigate("/reviews/new")}>
          New Review
        </Button>
      </Box>

      <Paper sx={{ p: 2, mt: 2 }}>
        {isLoading && <Typography>Loading...</Typography>}
        {!isLoading && reviews.length === 0 && (
          <Alert severity="info">You are not a member of any review yet.</Alert>
        )}
        <List>
          {reviews.map((review) => (
            <ListItem
              key={review._id}
              button
              divider
              onClick={() => navigate(`/reviews/${review._id}`)}
            >
              <ListItemText
                primary={review.title}
                secondary={review.question}
              />
              <Chip
                label={review.myRole || "admin view"}
                color={review.myRole === "owner" ? "secondary" : "default"}
                size="small"
                sx={{ mr: 1 }}
              />
              {review.status === "archived" && <Chip label="Archived" size="small" />}
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  );
};

export default Reviews;
